import { Action } from 'redux';
import { Inventory } from 'src/types/model';

export interface State {
  loading: boolean;
  data: Inventory[];
  error: string | null;
}

export const FETCH_INVENTORY_REQUEST = 'FETCH_INVENTORY_REQUEST';
export const FETCH_INVENTORY_SUCCESS = 'FETCH_INVENTORY_SUCCESS';
export const FETCH_INVENTORY_FAILURE = 'FETCH_INVENTORY_FAILURE';

export interface FetchInventoryRequestAction
  extends Action<typeof FETCH_INVENTORY_REQUEST> {}

export interface FetchInventorySuccessAction
  extends Action<typeof FETCH_INVENTORY_SUCCESS> {
  payload: Inventory[];
}

export interface FetchInventoryFailureAction
  extends Action<typeof FETCH_INVENTORY_FAILURE> {
  payload: string;
}

export type InventoryActionType =
  | FetchInventoryRequestAction
  | FetchInventorySuccessAction
  | FetchInventoryFailureAction;
